import type { ReactNode } from 'react';

interface EyebrowProps {
  children: ReactNode;
  color?: string;
}

const Eyebrow = ({ children, color = 'var(--gss-yellow-dark)' }: EyebrowProps) => (
  <p className="eyebrow-label" style={{ color }}>
    <span className="eyebrow-dot" style={{ background: color }} />
    {children}
  </p>
);

export default Eyebrow;
